import { VerseSelectOptionObj } from "../typings/verseSelectTypings";

export function isOptionsGrouped(options: VerseSelectOptionObj[]) {
  // if we pass a grouped option data, the options array item (object) wouldn’t have any value prop
  return typeof options?.[0]?.value !== "string";
}
